import DOMPurify from 'dompurify';
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { ckEditorStyleOverride } from '../../styles/ck-editor-override';

/**
 * Loader placeholder
 */
@customElement('lua-html-content')
export class LuaHtmlContent extends LitElement {
  static override styles = [
    ckEditorStyleOverride,
    css`
      :host {
        font-family: sans-serif;
      }
    `,
  ];

  @property()
  content: string;

  @property({ type: Boolean })
  useCkEditorStyles = false;

  protected override render() {
    const containerClass = this.useCkEditorStyles ? 'ck-editor-content' : '';
    return html`
      <div class=${containerClass}>${unsafeHTML(DOMPurify.sanitize(this.content, { ADD_TAGS: ['iframe'] }))}</div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lua-html-content': LuaHtmlContent;
  }
}
